import { checkNotifs } from "./browser_notifications";

if (navigator.serviceWorker && !window.location.pathname.includes("/users/sign_in")) {
  navigator.serviceWorker
    .register("/serviceworker.js", { scope: "/" })
    .then(function () {
      console.log("[Companion] Service worker registered!");
      checkNotifs();
    })
    .catch(function (error) {
      console.error("Service worker registration error: %o", error);
    });
}
